import AbstractListView from '@UI/Store/AbstractListView';
import type FacilityView from '@UI/Store/Facilities/Views/FacilityView';

/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class FacilitiesListView extends AbstractListView<FacilityView> {
	readonly organizationId: number;

	constructor(list: readonly FacilityView[], organizationId: number) {
		super(list, 'FacilitiesListView');

		this.organizationId = organizationId;

		Object.freeze(this);
	}

	addFacility(facility: FacilityView): FacilitiesListView {
		return new FacilitiesListView([...this.list, facility], this.organizationId);
	}

	updateFacility(facility: FacilityView): FacilitiesListView {
		return new FacilitiesListView(
			this.list.map((entry) => (entry.id === facility.id ? facility : entry)),
			this.organizationId,
		);
	}

	removeFacility(facilityId: number): FacilitiesListView {
		return new FacilitiesListView(
			this.list.filter((entry) => entry.id !== facilityId),
			this.organizationId,
		);
	}
}

export default FacilitiesListView;
